export const hackMatchMedia = () => {
  if (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    typeof window.matchMedia('all').addEventListener !== 'function'
  ) {
    var originalMatchMedia = window.matchMedia
    window.matchMedia = function(mediaQuery) {
      var mediaQueryList = originalMatchMedia(mediaQuery)
      var listeners = []

      mediaQueryList.addEventListener = function(event, callback) {
        listeners.push({
          event: event,
          callback: callback,
        })
      }

      mediaQueryList.handleChange = function() {
        listeners.forEach(function(listener) {
          if (listener.event === 'change') {
            listener.callback.call(mediaQueryList)
          }
        })
      }

      mediaQueryList.addListener = function(callback) {
        listeners.push({
          event: 'change',
          callback: callback,
        })
      }

      mediaQueryList.removeEventListener = function(event, callback) {
        listeners = listeners.filter(function(listener) {
          return !(listener.event === event && listener.callback === callback)
        })
      }

      mediaQueryList.removeListener = mediaQueryList.removeEventListener

      mediaQueryList.addListener(mediaQueryList.handleChange)

      return mediaQueryList
    }
  }
}
